import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { useHistory } from "react-router-dom";

const BlogItem = ({
  Image,
  Header,
  Id,
  formattedDate,
  Description1,
  Description,
}) => {
  const history = useHistory();

  const handleClick = (Id) => {
    console.log(Id);
    history.push({
      pathname: `/blog-deatils`,
      state: { Id }, // Passing the category in state
    });
  };

  return (
    <div className="blog-item" style={{ padding: "1rem" }}>
      <div className="bi-pic">
        <img
          style={{
            width: "100%",
            maxWidth: "27rem",
            height: "auto",
            borderRadius: "12px",
          }}
          src={Image}
          alt={Header}
        />
      </div>
      <div className="bi-text">
        <h5
          style={{
            fontWeight: "bold",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.5", // Adjust based on your font size and desired spacing
            maxHeight: "calc(1.5em * 4)", // line-height * number of lines
            textAlign: "justify",
          }}
        >
          {Header}
        </h5>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "0.5rem",
            alignItems: "center",
          }}
        >
          <div>
            by &nbsp;
            <span style={{ fontWeight: "bold", fontSize: "13px" }}>
              Nagesh Murthy
            </span>
          </div>
          <div>
            <p style={{ fontWeight: "bold", fontSize: "13px" }}>
              Date : {moment(formattedDate).format("MM/DD/YYYY")}
            </p>
          </div>
        </div>
        <p
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.5", // Adjust based on your font size and desired spacing
            maxHeight: "calc(1.5em * 4)", // line-height * number of lines
            textAlign: "justify",
          }}
        >
          {Description}
        </p>
        <div style={{ marginTop: "1rem" }}>
          <button
            className="site-btn"
            style={{
              padding: "8px",
              borderRadius: "4px",
            }}
            onClick={() => {
              handleClick(Id);
            }}
          >
            Read More
          </button>
        </div>
      </div>
    </div>
  );
};

BlogItem.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  commentsCount: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
};

export default BlogItem;
